import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Vue from 'vue';
import atom from '@tencent/vft-atom';
import qqsports from '@tencent/vft-atom/qqsports';
import env from '@tencent/vft-common/env';
import tenvideo from '@tencent/vft-common/tenvideo';
import Version from '@tencent/vft-common/Version';
import Onview from '@tencent/vft-onview';
import Scroll from "../AreaCode/scroll.vue";
import PwdDialog, { getPwd } from "../PwdDialog";
import { MQB_CHANNEL_MAP, MQB_SHARE_TYPE, MUSIC_CHANNEL_MAP, QQ_NEWS_CHANNEL_MAP, SUPPORTED_APP, WEISHI_CHANNEL_MAP } from "./const";
import Share from "./share";
import { getChannelConfigByEnv, loadMqbSdk, loadMusicSdk, loadQQNewSdk, loadWeiShiSdk } from "./util";
import { xqeShare } from "./xqe-share";
Vue.use(PwdDialog);
var supportedAppVersion = '6.9.0';
var supportedKidVersion = '6.4.0';
var toastTime = 5000;
export default {
  name: 'VuIconshare',
  components: {
    Scroll: Scroll
  },
  props: {
    dc: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    shareInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pwdInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    paddingLeft: {
      type: String,
      default: '38px'
    },
    reportModule: {
      type: String,
      default: ''
    },
    usePwd: {
      type: Boolean
    },
    onPwdCancel: {
      type: Function
    },
    wrap: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      appVersion: new Version(env.appVersion || '0.0.0'),
      channelName: {
        save: '保存本地',
        weixin: '微信',
        wxmoments: '朋友圈',
        doki: 'doki',
        qq: 'QQ',
        qzone: 'QQ空间',
        weibo: '微博'
      }
    };
  },
  computed: {
    isVisible: function isVisible() {
      return SUPPORTED_APP.includes(env.app);
    },
    channels: function channels() {
      var _this = this;

      var defaultChannels = getChannelConfigByEnv({
        originEnv: env.app,
        appVersion: this.appVersion,
        usePwd: this.usePwd
      });

      if (!this.shareInfo.dokiId) {
        defaultChannels = defaultChannels.filter(function (channel) {
          return channel.id !== 'doki';
        });
      }

      if (Array.isArray(this.dc) && this.dc.length) {
        return defaultChannels.filter(function (channel) {
          return _this.dc.indexOf(channel.id) === -1;
        });
      }

      return defaultChannels;
    }
  },
  created: function created() {
    var _this2 = this;

    tenvideo.tenvideoReady(function () {
      TenvideoJSBridge.on('onShareFinish', function () {
        if (_this2.sharing) {
          _this2.$emit('shareFinish');

          _this2.sharing = false;
        }
      });
    });
    console.log('------env.app-------', env.appVersion);
  },
  updated: function updated() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.$refs.scroll && _this3.$refs.scroll.refresh();
    });
  },
  methods: {
    saveImg: function saveImg(toast) {
      TenvideoJSBridge.invoke('saveImage', {
        imgbase64String: this.shareInfo.imgbase64,
        needSaveToAlbum: true
      }, function (res) {
        if (!toast) {
          return;
        }

        var json = JSON.parse(res);

        if (json && parseInt(json.errCode, 10) === 0) {
          atom.toast('保存到相册成功');
        } else {
          atom.toast('保存到相册失败');
        }
      });
    },
    save: function save() {
      var _this4 = this;

      var toast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var authRes = {
        PASS: 1,
        // 有权限
        DENY: 0 // 无权限

      };

      try {
        if (this.appVersion.compare(new Version('8.5.5'))) {
          // 版本判断
          TenvideoJSBridge.invoke('checkAppPermission', {
            permissionList: ['photo']
          }, function (checkRes) {
            var _JSON$parse, _JSON$parse$result;

            if (((_JSON$parse = JSON.parse(checkRes)) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$result = _JSON$parse.result) === null || _JSON$parse$result === void 0 ? void 0 : _JSON$parse$result.photo) !== authRes.PASS) {
              TenvideoJSBridge.invoke('requestAppPermission', {
                permissionList: [{
                  permissionName: 'photo',
                  requestText: '保存分享图需要您授权使用保存相册权限，以便功能的正常使用',
                  deniedText: '您已拒绝授权使用保存相册权限，无法正常使用该功能，请重新授权'
                }]
              }, function (reqRes) {
                var _JSON$parse2, _JSON$parse2$result;

                if (((_JSON$parse2 = JSON.parse(reqRes)) === null || _JSON$parse2 === void 0 ? void 0 : (_JSON$parse2$result = _JSON$parse2.result) === null || _JSON$parse2$result === void 0 ? void 0 : _JSON$parse2$result.photo) === authRes.PASS) {
                  _this4.saveImg(toast);
                } else {
                  atom.toast('保存到相册失败，无权限');
                }
              });
            } else {
              _this4.saveImg(toast);
            }
          });
        } else {
          this.saveImg(toast);
        }
      } catch (e) {
        console.error('保存到相册失败', e);
        atom.toast('保存到相册失败');
      }
    },
    share: function () {
      var _share = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(channelParam) {
        var channel;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                channel = channelParam; // 参数重新定义为了对象，为了兼容老的字符串调用

                if (typeof channelParam === 'string') {
                  channel = {
                    id: channelParam
                  };
                } // 小企鹅app内低于6.4.0在走特殊逻辑


                if (!(env.isKidApp && !this.appVersion.compare(supportedKidVersion))) {
                  _context.next = 6;
                  break;
                }

                if (channel.usePwd) {
                  this.pwdShare(channel.id);
                } else {
                  xqeShare(channel.id, this.shareInfo);
                }

                this.$emit('shareClick', channel.id);
                return _context.abrupt("return");

              case 6:
                if (this.shareInfo.imgbase64) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                _context.next = 10;
                return this.shareHandler(channel);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function share(_x) {
        return _share.apply(this, arguments);
      }

      return share;
    }(),
    shareHandler: function () {
      var _shareHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(channel) {
        var shareFn;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                shareFn = "".concat(env.app, "ShareHandler");

                if (env.app === 'app' || env.app === 'kidapp') {
                  shareFn = 'tenvideoShareHandler';
                }

                this[shareFn](channel);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function shareHandler(_x2) {
        return _shareHandler.apply(this, arguments);
      }

      return shareHandler;
    }(),
    qqsportsShareHandler: function qqsportsShareHandler(channel) {
      // 腾讯体育
      return qqsports.shareTo({
        type: channel.id,
        imgbase64: this.shareInfo.imgbase64
      });
    },
    qqbrowserShareHandler: function () {
      var _qqbrowserShareHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(channel) {
        var isSupport, imgData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // qq浏览器
                isSupport = this.qqbrowserVersionCheck();

                if (isSupport) {
                  _context3.next = 4;
                  break;
                }

                this === null || this === void 0 ? void 0 : this.toast('当前app版本较低，请升级app或直接截图分享', toastTime);
                return _context3.abrupt("return");

              case 4:
                _context3.next = 6;
                return loadMqbSdk();

              case 6:
                imgData = env.isAndroid ? this.shareInfo.imgbase64.replace(/data:.*base64,/, '') : this.shareInfo.imgbase64;
                return _context3.abrupt("return", window.browser.app.share({
                  img_data: imgData,
                  to_app: MQB_CHANNEL_MAP[channel.id],
                  share_type: MQB_SHARE_TYPE.pic
                }));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function qqbrowserShareHandler(_x3) {
        return _qqbrowserShareHandler.apply(this, arguments);
      }

      return qqbrowserShareHandler;
    }(),
    weishiShareHandler: function () {
      var _weishiShareHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(channel) {
        var shareIns, weiShiShare;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return loadWeiShiSdk();

              case 2:
                shareIns = new window.H5_SHARE();
                _context4.next = 5;
                return shareIns.config({
                  shareInfo: {
                    title: '',
                    desc: '',
                    imgUrl: null,
                    link: window.location.href,
                    type: 'base64',
                    // ['base64','link'] base64 表示分享的是图片的base64 数据
                    base64: this.shareInfo.imgbase64 // optional 图片的base64 信息

                  }
                });

              case 5:
                weiShiShare = _context4.sent;
                return _context4.abrupt("return", weiShiShare.api[WEISHI_CHANNEL_MAP[channel.id]]());

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function weishiShareHandler(_x4) {
        return _weishiShareHandler.apply(this, arguments);
      }

      return weishiShareHandler;
    }(),
    qqnewsShareHandler: function () {
      var _qqnewsShareHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(channel) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return loadQQNewSdk();

              case 2:
                return _context5.abrupt("return", window.TencentNews.invoke('share', {
                  destination: QQ_NEWS_CHANNEL_MAP[channel.id]
                }));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function qqnewsShareHandler(_x5) {
        return _qqnewsShareHandler.apply(this, arguments);
      }

      return qqnewsShareHandler;
    }(),
    qqmusicShareHandler: function () {
      var _qqmusicShareHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(channel) {
        var _this5 = this;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.appVersion.compare('6.1.0')) {
                  _context6.next = 3;
                  break;
                }

                this === null || this === void 0 ? void 0 : this.toast('当前app版本较低，请升级app或直接截图分享', toastTime);
                return _context6.abrupt("return");

              case 3:
                _context6.next = 5;
                return loadMusicSdk();

              case 5:
                if (!(channel.id === 'save')) {
                  _context6.next = 8;
                  break;
                }

                window.M.client.invoke('media', 'saveImage', {
                  content: this.shareInfo.imgbase64
                }, function (ret) {
                  if ("".concat(ret.code) === '0') {
                    _this5 === null || _this5 === void 0 ? void 0 : _this5.toast('保存成功！', toastTime);
                  }
                });
                return _context6.abrupt("return");

              case 8:
                window.M.client.invoke('other', 'callShareImg', {
                  imgUrl: this.shareInfo.imgbase64,
                  target: MUSIC_CHANNEL_MAP[channel.id]
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function qqmusicShareHandler(_x6) {
        return _qqmusicShareHandler.apply(this, arguments);
      }

      return qqmusicShareHandler;
    }(),
    tenvideoShareHandler: function tenvideoShareHandler(channel) {
      // 腾讯视频
      if (channel.id === 'save') {
        this.save();
        this.$emit('shareClick', channel.id);
      } else {
        if (channel.id !== 'doki' && !env.isLiteApp && !env.isKidApp && !this.appVersion.compare(supportedAppVersion) && this.shareInfo.isShareImageOnly !== false) {
          this === null || this === void 0 ? void 0 : this.toast('当前app版本较低，请升级至6.9.0及以上版本', toastTime);
          this.$emit('lowAppVer', '当前app版本较低，请升级至6.9.0及以上版本');
          return;
        }

        this.sharing = true;

        if (channel.usePwd) {
          this.pwdShare(channel.id);
        } else {
          Share.openShare(channel.id, _objectSpread({
            isShareImageOnly: true
          }, this.shareInfo));
        }

        this.$emit('shareClick', channel.id);
      }
    },
    qqbrowserVersionCheck: function qqbrowserVersionCheck() {
      if (env.isIos && !this.appVersion.compare('12.2.4')) {
        return false;
      }

      if (env.isAndroid && !this.appVersion.compare('11.9.0')) {
        return false;
      }

      return true;
    },
    pwdShare: function pwdShare(channel) {
      var _this6 = this;

      if (this.lockGetPwd) {
        return;
      }

      this.lockGetPwd = true;
      getPwd({
        pageId: this.pwdInfo.pageId,
        jumpUrl: this.pwdInfo.jumpUrl
      }).then(function (res) {
        _this6.$createPwdDialog({
          $props: {
            channel: channel,
            thumbpic: _this6.shareInfo.imgbase64,
            pwds: res[channel]
          },
          $events: {
            cancel: function cancel() {
              _this6.onPwdCancel && _this6.onPwdCancel();
            }
          }
        }).show();

        if (channel === 'wxmoments') {
          _this6.save(false);
        }

        _this6.$emit('popPwdDialog');
      }, function (e) {
        _this6 === null || _this6 === void 0 ? void 0 : _this6.toast('服务异常请重试');
      }).then(function () {
        _this6.lockGetPwd = false;
      });
    },
    scrollHandler: function scrollHandler() {
      Onview.triggerCompute();
    }
  },
  reportData: {
    save: {
      f_type: 4,
      f_resource: '保存本地btn'
    },
    weixin: {
      f_type: 4,
      f_resource: '分享微信btn'
    },
    wxmoments: {
      f_type: 4,
      f_resource: '分享朋友圈btn'
    },
    doki: {
      f_type: 4,
      f_resource: '分享dokibtn'
    },
    qq: {
      f_type: 4,
      f_resource: '分享QQbtn'
    },
    qzone: {
      f_type: 4,
      f_resource: '分享QQ空间btn'
    },
    weibo: {
      f_type: 4,
      f_resource: '分享微博btn'
    }
  }
};